import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'sortBy' })
export class SortByPipe implements PipeTransform {

  transform(value: any[], column: string, order = ''): any[] {
    if (!value || !column || column === '' || order === '') { return value; } // no array
    if (value.length <= 1) { return value; } // array with only one item

    // const test = value.sort((a, b) => {
      // if ( a[column] === undefined || b[column] === undefined ) { return -1; }

      // if( !a[column] || !b[column] ) { return -1; }
      // return (a[column] > b[column]) ? 1 : -1;
    // });

    // test.forEach(item => {
      // console.log(item.avg_rank);
    // });

    // return;

    return _.orderBy(value, [column], [order]);
  }
}